import React from 'react';
import { useTranslation } from 'react-i18next';
import './BoutiqueBadges.css';

export default function BoutiqueBadges({ boutique, className = '' }) {
  const { t } = useTranslation('common');
  if (!boutique) return null;

  const isPinned = boutique.isPinned || boutique.isPlatformStore;
  const isPromoted =
    boutique.isPromotionActive ||
    (boutique.isPromoted && !isPinned);

  return (
    <div className={`boutique-badges ${className}`.trim()}>
      {isPinned && (
        <span className="boutique-badge boutique-badge--pinned">
          {t('boutiqueBadgeOfficial')}
        </span>
      )}
      {isPromoted && !isPinned && (
        <span className="boutique-badge boutique-badge--promoted">
          {t('boutiqueBadgePromoted')}
        </span>
      )}
    </div>
  );
}
